import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  title: 'Identifica',
  desc: 'Localiza las fugas de tiempo y los clientes que drenan tu energía sin pagar lo justo.'
}, {
  title: 'Filtra',
  desc: 'Aplica el Sistema de Triple Filtro a cada demanda entrante para proteger tu enfoque.'
}, {
  title: 'Escala',
  desc: 'Implementa el Onboarding de Élite para atraer y retener clientes que valoran tu liderazgo, no solo tu tiempo.'
}];
export function HowItWorksSection() {
  return <section className="py-20 md:py-32 bg-white" data-id="element-102">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-103">
        <FadeIn data-id="element-104">
          <div className="text-center mb-20" data-id="element-105">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-106">
              Cómo funciona
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-107"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-108">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-cream z-0" data-id="element-109"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-110">
              <div className="flex flex-col items-center text-center" data-id="element-111">
                <div className="w-24 h-24 bg-brand-cream rounded-full flex items-center justify-center border-4 border-white shadow-md mb-8" data-id="element-112">
                  <span className="text-3xl font-serif font-bold text-brand-gold" data-id="element-113">
                    {index + 1}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-brand-charcoal mb-4 font-sans" data-id="element-114">
                  {step.title}
                </h3>
                <p className="text-brand-charcoal/70 leading-relaxed" data-id="element-115">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}